var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "h-100 d-flex flex-column",
      class: { disabled: _vm.isActive === false },
    },
    [
      _c("div", { staticClass: "sidebar-item" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center gap-20 justify-content-between",
            on: { click: _vm.activate },
          },
          [
            _c("div", { staticClass: "d-flex gap-20 align-items-center" }, [
              _c(
                "span",
                {
                  staticClass: "main-number",
                  class: {
                    disabled: _vm.isActive === false,
                    done: _vm.isDone === true,
                  },
                },
                [_vm._v("4")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "font-size-125" }, [
                _vm._v(_vm._s(_vm._f("trans")("Settings"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", {
              on: {
                click: function ($event) {
                  _vm.item_open = !_vm.item_open
                },
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.activeStage.activeStep === "settings"
        ? _c("div", { staticClass: "flex-1 sidebar-item d-flex flex-column" }, [
            _c(
              "div",
              { staticClass: "d-flex gap-40px flex-column flex-1 h-100" },
              [
                _c(
                  "div",
                  { staticClass: "d-flex gap-40px flex-column flex-1" },
                  [_vm._m(0), _vm._v(" "), _c("generate-btn")],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex flex-column gap-20px flex-1" }, [
      _c("span", { staticClass: "alert alert-info" }, [_vm._v("No settings")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }